import { CENTRA_MARKET_CODE, CentraMarketCode } from "@/data/supported-markets"

export type MarketIdToMarketCodeMap = Map<number, CentraMarketCode>

const marketIdToMarketCodeMap: MarketIdToMarketCodeMap = new Map<
    number,
    CentraMarketCode
>([
    [1, CENTRA_MARKET_CODE.Jp],
    [4, CENTRA_MARKET_CODE.Eu],
    [5, CENTRA_MARKET_CODE.Na],
    [6, CENTRA_MARKET_CODE.Apac]
])

export default marketIdToMarketCodeMap
